import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Grid,
  Typography,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import ExpandMore from "@material-ui/icons/ExpandMore";
import classnames from "classnames";
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { SectionTitle } from "../CommonComponents";
import { ewbConfig } from "config";

const styles = (theme) => ({
  paperPadding: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
  }),
  cardPadding: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: theme.spacing(3),
  }),
  bottomMargin: {
    marginBottom: 20,
  },
  bold: {
    fontWeight: "700",
  },
  spacer: {
    marginTop: "15px",
    marginBottom: "15px",
  },
  promoButton: {
    width: "100%",
    marginBottom: "10px",
  },
  modalButtonStyling: {
    textTransform: "inherit",
    fontWeight: "unset",
    padding: "0",
    lineHeight: "unset",
    display: "contents",
  },
  borderZero: {
    "& > div:last-child  ": {
      border: "none",
    },
  },
  benefitBorder: {
    padding: "16px 25px",
    borderRight: "2px solid #ddd",
    [theme.breakpoints.down("sm")]: {
      borderRight: "none",
      borderBottom: "2px solid #ddd",
    },
  },

  serviceBorder: {
    paddingLeft: "25px!important",
    borderRight: "2px solid #ddd",
    [theme.breakpoints.down("sm")]: {
      borderRight: "none",
      borderBottom: "2px solid #ddd",
      padding: "16px 15px",
    },
    // [theme.breakpoints.up('md')]: {
    // 	'& p + p': {
    // 		paddingBottom: '2.5rem!important',
    // 	},
    // },
  },
  buttonBottom: {
    marginTop: "10px",
    [theme.breakpoints.up("md")]: {
      position: "absolute",
      bottom: "5px",
    },
  },
  rounderNumber: {
    backgroundColor: theme.palette.secondary.main,
    width: "40px",
    height: "35px",
    borderRadius: "30px",
    margin: "15px auto",
    color: "#fff",
    paddingTop: "3px",
  },
  applySteps: {
    "& div:last-child > img ": {
      display: "none",
    },
  },
  rounderBorder: {
    borderRadius: "8px",
  },
  listPadding: {
    paddingTop: 0,
    listStyleType: "disc",
  },
  formControl: {
    position: "relative",
    top: "7px",
  },
  feesFirst: {
    backgroundColor: "#c6d147",
    width: "35%",
  },
  feesLast: {
    border: "solid 1px #d6d6d6",
  },
  // slider
  carouselStyling: {
    height: "310px",
    display: "flex!important",
    [theme.breakpoints.down("sm")]: {
      position: "relative",
    },
    "& > div:first-child": {
      backgroundColor: "#c6d147",
      paddingLeft: theme.spacing(2),
      [theme.breakpoints.down("sm")]: {
        backgroundColor: "rgba(198, 209, 71, 0.7)",
        position: "absolute",
        height: "310px",
      },
      [theme.breakpoints.up("md")]: {
        position: "relative",
      },
    },
    [theme.breakpoints.up("md")]: {
      height: "350px",
      "& > div": {
        [theme.breakpoints.up("md")]: {
          width: "50%",
        },
      },
    },
  },
  carouselAligner: {
    position: "relative",
    [theme.breakpoints.up("md")]: {
      justifyContent: "flex-end",
    },
  },
  carouselImage: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  carouselText: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    "& hr": {
      borderColor: "black",
      borderWidth: "0.5px",
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    "& h3": {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
  },
  extendedHr: {
    position: "absolute",
    width: "40%",
    top: "48px",
    right: "0",
    [theme.breakpoints.only("sm")]: {
      width: "70%",
    },
    "& hr": {
      borderColor: "black",
      borderWidth: "0.5px",
    },
  },
  pageBanner: {
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "top center",
    minHeight: "225px",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      // backgroundImage: 'none!important',
      boxShadow: "inset 0 0 0 300px rgba(212, 211, 225, 0.9)",
      backgroundPositionX: "75%!important",
    },
  },
  navButton: {
    color: "#fff",
    marginRight: "5px",
    fontSize: "14px",
    [theme.breakpoints.up("lg")]: {
      fontSize: "18px",
      marginRight: "20px",
    },
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
    },
    "&:focus": {
      backgroundColor: theme.palette.secondary.main,
    },
  },
  navaffix: {
    "& div > a:first-child": {
      marginLeft: "17px",
    },
  },
  // carousel styling
  multipleItemSlider: {
    width: "300px",
  },
  multiCarouselContent: {
    position: "relative",
    "& div": {
      backgroundColor: "rgba(237, 236, 237, 0.7)",
      position: "absolute",
      padding: "1.25rem",
      borderRadius: "6px",
      [theme.breakpoints.up("md")]: {
        marginLeft: "1.25rem",
        width: "50%",
        top: "50%",
        transform: "translateY(-50%)",
      },
      [theme.breakpoints.down("sm")]: {
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        "& button": {
          alignSelf: "flex-start",
        },
      },
    },
  },
  chevronPurple: {
    borderStyle: "solid",
    borderWidth: "3px",
    borderColor: theme.palette.secondary.main,
    fontSize: "3rem",
    color: theme.palette.secondary.main,
    borderRadius: "100%",
    position: "relative",
    top: "-20px",
    [theme.breakpoints.only("md")]: {
      fontSize: "2.5rem",
    },
  },
  chevronWhite: {
    borderStyle: "solid",
    borderWidth: "3px",
    borderColor: "#fff",
    fontSize: "3rem",
    color: "#fff",
    borderRadius: "100%",
    position: "relative",
    top: "-20px",
  },
  linkHover: {
    marginTop: "10px",
    padding: "0 20px",
    "& a:hover": {
      textDecoration: "underline!important",
      color: theme.palette.primary.main,
    },
  },

  search: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    display: "inline-flex",
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    width: "85%",
    backgroundColor: "#fff",
    boxShadow: "3px 3px #888888",
    height: "50px",
    "& a:hover": {
      backgroundColor: theme.palette.secondary.main,
    },
  },
  searchIcon: {
    width: theme.spacing(0),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    color: "#fff",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
    width: "100%",
  },
  inputInput: {
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(2),
  },
  searchBtn: {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: "4px",
  },
  heading: {
    fontSize: theme.typography.pxToRem(16),
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(14),
  },
  card: {
    marginBottom: "25px",
    [theme.breakpoints.down("xs")]: {
      boxShadow: "none",
    },
  },
  actions: {
    display: "block",
    [theme.breakpoints.up("sm")]: {
      display: "flex",
    },
  },
  // expand: {
  // 	transform: 'rotate(0deg)',
  // 	transition: theme.transitions.create('transform', {
  // 		duration: theme.transitions.duration.shortest,
  // 	}),
  // },
  textUppercase: {
    textTransform: "capitalize",
  },
  templateTable: {
    "& thead": {
      backgroundColor: "#4d2679",
      "& p": {
        color: "#fff",
      },
    },
    "& tbody  tr td:first-child": {
      backgroundColor: "#c6d147",
    },
    "& tbody tr td:not:first-child": {
      backgroundCOlor: "#fff",
    },
  },
  tableResponsive: {
    width: "100%",
    overflowX: "auto",
  },
  cardHeight: {
    [theme.breakpoints.between("sm", "md")]: {
      "& > p + p": {
        height: "60px",
      },
      "& p:last-child": {
        height: "115px",
        overflow: "hidden",
      },
    },
    "@media (min-width: 1280px) and (max-width: 1550px)": {
      "& > p + p": {
        height: "65px",
      },
      "& p:last-child": {
        height: "140px",
        overflow: "hidden",
      },
    },
    "@media (min-width: 1551px) and (max-width: 1919px)": {
      "& > p + p": {
        height: "65px",
      },
      "& p:last-child": {
        height: "115px",
        overflow: "hidden",
      },
    },
    [theme.breakpoints.only("xl")]: {
      "& > p + p": {
        height: "65px",
      },
      "& p:last-child": {
        height: "120px",
        overflow: "hidden",
      },
    },
  },
  // about us css

  brokerImg: {
    width: 190,
  },
  brokerInfo: {
    "& hr": {
      margin: "25px auto",
    },
    "& img": {
      width: 190,
    },
  },

  // about
  aboutSlider: {
    backgroundColor: "#fff",
    display: "flex!important",
    margin: "0 auto",
    width: "95%!important",
  },
});

// About us

const RenderNews2 = withStyles(styles)(function ({
  classes,
  newsArray,
  url,
  xs = 12,
  sm = 6,
  md = 4,
  hideDate = false,
  showImage = false,
}) {
  return (
    <>
      {newsArray.map(function (news, index) {
        return (
          <Grid item xs={xs} sm={sm} md={md} key={index}>
            <Card className={classes.rounderBorder}>
              {showImage && (
                <CardMedia
                  image={
                    ewbConfig.appDomain +
                    news.field_feature_image?.replace(/\\\//g, "/")
                  }
                  className="cardImage"
                />
              )}
              <CardContent
                className={classes.cardHeight}
                style={{ height: 180 }}
              >
                {!hideDate && (
                  <Typography
                    gutterBottom
                    color="primary"
                    variant="body2"
                    className={classes.bold}
                  >
                    {news.field_date}
                  </Typography>
                )}
                <Typography
                  className={classnames(classes.newsHeadline, classes.bold)}
                  gutterBottom
                  variant="body1"
                  color="primary"
                  dangerouslySetInnerHTML={{ __html: news.title }}
                />

                <div
                  className="line-clamp-4"
                  variant="body"
                  dangerouslySetInnerHTML={{ __html: news.body }}
                />
              </CardContent>
              <CardActions
                style={{ paddingLeft: "18px", paddingBottom: "1rem" }}
              >
                <Button
                  component={Link}
                  to={`/about/newsroom/${news.nid}`}
                  size="medium"
                  variant="contained"
                  color="secondary"
                  className={classes.promoButton}
                >
                  Read More
                </Button>
              </CardActions>
            </Card>
          </Grid>
        );
      })}
    </>
  );
});

const RenderNews = withStyles(styles)(function ({ classes, newsArray, url }) {
  // console.log(match)
  return (
    <div className={classnames(classes.spacer, classes.paperPadding)}>
      <div className={classes.paperPadding}>
        <Grid container spacing={2} alignItems="center">
          {newsArray.map(function (news, index) {
            return (
              <Grid item xs={12} sm={6} lg={4} xl={4} key={index}>
                <Card className={classes.rounderBorder}>
                  <CardMedia image={news.image} className="cardImage" />
                  <CardContent className={classes.cardHeight}>
                    <Typography gutterBottom color="primary" variant="body2">
                      {news.date}
                    </Typography>
                    <div>
                      <Typography
                        className={classnames(
                          classes.newsHeadline,
                          classes.bold
                        )}
                        gutterBottom
                        variant="h6"
                        color="primary"
                      >
                        {news.headline}
                      </Typography>
                    </div>
                    <Typography
                      className={classes.newsBody}
                      variant="body2"
                      color="primary"
                      dangerouslySetInnerHTML={{ __html: news.blurb }}
                    />
                  </CardContent>
                  <CardActions
                    style={{ paddingLeft: "18px", paddingBottom: "1rem" }}
                  >
                    <Button
                      component={Link}
                      to={`/about/newsroom/${news.id}`}
                      size="medium"
                      variant="contained"
                      color="secondary"
                      className={classes.promoButton}
                    >
                      Read More
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </div>
    </div>
  );
});

const RenderCareer = withStyles(styles)(function ({
  classes,
  careerArray,
  handleClick,
}) {
  return (
    <div className={classnames(classes.spacer, classes.paperPadding)}>
      <Grid container spacing={2}>
        <Grid item xs={12} lg={12} xl={7}>
          {careerArray.map(function (news, index) {
            return (
              <Fragment>
                <Grid item xs={12} key={news.id}>
                  <Accordion>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <div>
                        <Typography
                          className={classes.bold}
                          gutterBottom
                          variant="body2"
                        >
                          {news.organization_name}
                        </Typography>
                        <div className="spacer" />
                        <Typography
                          color="primary"
                          className={classnames(classes.bold)}
                          variant="h6"
                        >
                          {news.position_name}
                        </Typography>
                        <div className="spacer" />
                        <Typography
                          className={classes.bold}
                          variant="body1"
                          dangerouslySetInnerHTML={{
                            __html: "Location: " + news.location_display,
                          }}
                        />
                      </div>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div>
                        <div className="spacer" />
                        <Typography
                          variant="body2"
                          dangerouslySetInnerHTML={{ __html: news.description }}
                        />
                        <br />

                        <div className="spacer" />
                        <br />
                        <Button
                          size="medium"
                          variant="contained"
                          color="secondary"
                          // onClick={() => handleClick(news.id)}
                          href={`https://www.careers-page.com/eastwest-bank/job/${news.hash}/apply`}
                          target="_blank"
                        >
                          Apply Now
                        </Button>
                      </div>
                    </AccordionDetails>
                    {/* </CardActions> */}
                  </Accordion>
                </Grid>
                <div className="spacer" />
              </Fragment>
            );
          })}
        </Grid>
      </Grid>
    </div>
  );
});

const RenderOneVideo = withStyles(styles)(function ({ classes, header, src }) {
  return (
    <div className={classnames(classes.spacer, classes.paperPadding)}>
      <SectionTitle header={header} fontColor="primary" />
      <div className={classes.paperPadding}>
        <Grid container wrap-reverse>
          <Grid item md={2} />
          <Grid item xs={12} sm={12} md={8}>
            <div className="videoWrapper" style={{ marginBottom: "70px" }}>
              <iframe
                title="Eastwest who we are video "
                src={src}
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              />
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
});

export { RenderNews, RenderNews2, RenderOneVideo, RenderCareer };
